import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-instagram-svg',
  templateUrl: './instagram-svg.component.html',
  styleUrls: ['./instagram-svg.component.scss']
})
export class InstagramSvgComponent {
  @HostBinding('class') classes = 'market-quest-icon ';
  @Input() size = 24;
  @Input() fillColor = '#1f69ff';

  constructor() {}
}
